import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Presentation from './Presentation';

ReactDOM.render(<Presentation />, document.getElementById('root'));
